import { http } from '../../config/axios'

 const findPlano = (params:any): Promise<any> => {
  const sanitizedParams = params ? { ...params } : params;
  if (sanitizedParams && sanitizedParams.descricao) {
    // busca no backend e LIKE contains: nbsp/quebras de linha/espacos duplos e reticencias
    // de copy/paste de relatorio quebram o match se nao forem normalizados aqui
    sanitizedParams.descricao = String(sanitizedParams.descricao)
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .normalize('NFC')
      .replace(/[ ​-‍﻿]/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/[.…]+$/, '')
      .trim() || params.descricao;
  }
  const queryParams = sanitizedParams
                ? Object.keys(sanitizedParams)
                      .map((k) => encodeURIComponent(sanitizedParams[k]))
                      .join('/')
                : '';
  return http
    .get('api/plano/find/' + queryParams)
    .then((res) => {
      if(res.data && res.data.planos && res.data.planos.length > 0){
        res.data.planos.forEach((p:any) => {
          p.planosServico.forEach((ps:any) => {
            ps.planosServicoValor.forEach((psv:any) => {
              psv.data = new Date(psv.data)
            });
            ps.planosServicoValor.sort((a:any, b:any) => a.data.getTime() - b.data.getTime());
          });
        });
      }
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findPlano', error)
      throw Error(error.response.data)
    })
}

export default findPlano;
